import { translateData } from "../lang/lang";
import { countries, loadCountries } from "./countries";
import { datepickerSetup, DEFAULT_END, DEFAULT_START, permalinkFeature, setDate, triggerDateChange } from "./datepicker";
import { selectCountRange, selectEntries, selectSharpDates, setSelectEntriesValues, setSelectSharpDatesValues } from "./filter";
import { info, toggleTravels } from "./layout";
import { chronologicalLegendItems, entriesLegendItems, legend, travelsLegendItems } from "./legend";
import { popup, selectfeature, templateEn, templatePl } from "./popupFeature";
import { itineraryLabelPlaces, selectDataStyleFunctionEN, selectDataStyleFunctionPL, stylePlacesFunctionEn, stylePlacesFunctionPl } from "./source";


export function loadLanguageOL(lang, key) {

    if (lang == 'en')
        var language = 0
    else
        var language = 1

    if (translateData[language][key]) {
        return translateData[language][key];
    }
    else {
        return 'Missing translation';
    }
}

function loadLanguage(lang) {

    if (lang == 'en')
        var language = 0
    else
        var language = 1

    $('[data-translate]').each(function () {
        var key = $(this).data('translate');

        $(this).text(translateData[language][key] || 'Missing translation');
    });

}

$(window).on('load', function () {
    if (permalinkFeature.getUrlParam('lang')) {
        if (permalinkFeature.getUrlParam('lang') == 'en')
            loadLanguageEN();
        else
            loadLanguagePL();
    }

    else {
        permalinkFeature.setUrlParam('lang', 'en');
        loadLanguageEN();
    }
});

function loadLanguagePL() {
    $(".lang").text("pl");
    loadLanguage('pl');


    $('#datapanel_top img').attr("src", "./assets/images/logo_itinerary_pl.png");


    popup.setTemplate(templatePl)
    $('#filterYear .form-check-label').attr('data-bs-original-title', loadLanguageOL('pl', 'routeTooltip'))

    toggleTravels.bootstrapToggle('destroy')
    toggleTravels.bootstrapToggle({
        onlabel: loadLanguageOL('pl', 'travelsLabel'),
        offlabel: loadLanguageOL('pl', 'travelsLabel'),
        size: "sm"
    });
    toggleTravels.bootstrapToggle()

    $('.search_places input').attr('placeholder', loadLanguageOL('pl', 'searchPlaceholder'))

    legend.removeItemAt(2)
    legend.removeItemAt(1)
    legend.removeItemAt(0)

    legend.addItem(entriesLegendItems('pl'))
    legend.addItem(travelsLegendItems('pl'))
    legend.addItem(chronologicalLegendItems('pl'))

    loadCountries('pl', countries)
    info('pl')

    selectEntries.element.querySelector('LABEL').innerHTML = loadLanguageOL('pl', 'filterEntries')
    selectSharpDates.element.querySelector('LABEL').innerHTML = loadLanguageOL('pl', 'filterSharpDates')
    selectCountRange.element.querySelector('LABEL').innerHTML = loadLanguageOL('pl', 'filterCountRange')

    itineraryLabelPlaces.setStyle(stylePlacesFunctionPl)


    selectEntries.setValues({ values: setSelectEntriesValues('pl') })
    selectSharpDates.setValues({ values: setSelectSharpDatesValues('pl') })
    $('.entriesPopup select option.ol-default').html(loadLanguageOL('pl', 'allEntries'));
    $('.datesPopup select option.ol-default').html(loadLanguageOL('pl', 'allDates'));
    $('.rangesPopup select option.ol-default').html(loadLanguageOL('pl', 'allRanges'));

    datepickerSetup('pl')

    if (permalinkFeature.getUrlParam('startDate')) {
        var startDate = permalinkFeature.getUrlParam('startDate');
        var endDate = permalinkFeature.getUrlParam('endDate');
    } else {
        startDate = DEFAULT_START;
        endDate = DEFAULT_END;
    }
    setDate(startDate, endDate);

    $('#daterange').on('cancel.daterangepicker', function (ev, picker) {
        setDate(DEFAULT_START, DEFAULT_END);
        picker.show();
    });
    $('#daterange').on('apply.daterangepicker', function (ev, picker) {
        startDate = picker.startDate.format('YYYY-MM-DD');
        endDate = picker.endDate.format('YYYY-MM-DD');

        triggerDateChange(startDate, endDate);
    });

    permalinkFeature.setUrlParam('lang', 'pl');

    selectfeature.style_ = selectDataStyleFunctionPL

};

function loadLanguageEN() {
    $(".lang").text("en");
    loadLanguage('en');

    $('#datapanel_top img').attr("src", "./assets/images/logo_itinerary_en.png");

    popup.setTemplate(templateEn)
    $('#filterYear .form-check-label').attr('data-bs-original-title', loadLanguageOL('en', 'routeTooltip'))

    toggleTravels.bootstrapToggle('destroy')
    toggleTravels.bootstrapToggle({
        onlabel: loadLanguageOL('en', 'travelsLabel'),
        offlabel: loadLanguageOL('en', 'travelsLabel'),
        size: "sm"
    });
    toggleTravels.bootstrapToggle()

    $('.search_places input').attr('placeholder', loadLanguageOL('en', 'searchPlaceholder'))

    legend.removeItemAt(2)
    legend.removeItemAt(1)
    legend.removeItemAt(0)

    legend.addItem(entriesLegendItems('en'))
    legend.addItem(travelsLegendItems('en'))
    legend.addItem(chronologicalLegendItems('en'))

    loadCountries('en', countries)
    info('en')

    selectEntries.element.querySelector('LABEL').innerHTML = loadLanguageOL('en', 'filterEntries')
    selectSharpDates.element.querySelector('LABEL').innerHTML = loadLanguageOL('en', 'filterSharpDates')
    selectCountRange.element.querySelector('LABEL').innerHTML = loadLanguageOL('en', 'filterCountRange')

    itineraryLabelPlaces.setStyle(stylePlacesFunctionEn)

    selectEntries.setValues({ values: setSelectEntriesValues('en') })
    selectSharpDates.setValues({ values: setSelectSharpDatesValues('en') })
    $('.entriesPopup select option.ol-default').html(loadLanguageOL('en', 'allEntries'));
    $('.datesPopup select option.ol-default').html(loadLanguageOL('en', 'allDates'));
    $('.rangesPopup select option.ol-default').html(loadLanguageOL('en', 'allRanges'));

    datepickerSetup('en')
    if (permalinkFeature.getUrlParam('startDate')) {
        var startDate = permalinkFeature.getUrlParam('startDate');
        var endDate = permalinkFeature.getUrlParam('endDate');
    } else {
        startDate = DEFAULT_START;
        endDate = DEFAULT_END;
    }

    setDate(startDate, endDate);

    $('#daterange').on('cancel.daterangepicker', function (ev, picker) {
        setDate(DEFAULT_START, DEFAULT_END);
        picker.show();
    });
    $('#daterange').on('apply.daterangepicker', function (ev, picker) {
        startDate = picker.startDate.format('YYYY-MM-DD');
        endDate = picker.endDate.format('YYYY-MM-DD');

        triggerDateChange(startDate, endDate);
    });

    permalinkFeature.setUrlParam('lang', 'en');

    selectfeature.style_ = selectDataStyleFunctionEN
};

$(".langpl").on("click", function () {
    loadLanguagePL();
});

$(".langen").on("click", function () {
    loadLanguageEN();
});

